export default {
  getHead: () => {
    return [{name: '현장명'}, {name: '부서'}, {name: '작성자'}, {name: '직급'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).inputA_2
      case 2: return func.getContent(value).inputA_3
      case 3: return func.getContent(value).inputA_4
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_5) {
      nav.dateTarget = 'content$body.inputA_5'
      nav.dateBegin = 'nav.value.inputA_5.sDate'
      nav.dateEnd = 'nav.value.inputA_5.eDate'
    }
    return {inputA_5: nav.value.inputA_5}
  },
  getSearchKeyword: (nav) => {
    return []
  },
}
